import { Navigate, useLocation, useNavigate } from "react-router-dom";
import "./ClientInfo.css";
import Header from "../Header";
import React, { useEffect, useState } from "react";
import RadioButton from "../RadioButton";
import { enHSInstance } from "../../App";
import ConnectionError from "../ConnectionError/ConnectionError";

export default function ClientInfo() {
  const location = useLocation();
  const navigate = useNavigate();

  const clientData = location.state?.clients;
  const date = new Date(clientData?.registerDate);

  const [isApproved, setIsApproved] = useState("");
  const [checked, setChecked] = useState(false);
  const [approvalError, setApprovalError] = useState(null);

  const handleClientApprovement = async () => {
    if (!clientData) return;
    setApprovalError(null);

    try {
      const response = await enHSInstance.post(
        `https://api-erkon.tech/mobile/hs/ObmenMP/approveRegistration`,
        {
          number: clientData.number,
          approved: isApproved,
          FIO: clientData.FIO,
          fullAccess: !checked,
        },
        {
          headers: {
            token: localStorage.getItem("tokenMANAGER"),
          },
        },
      );
      if (response.status === 200) {
        navigate("/");
      } else {
        setApprovalError(response.status);
      }
    } catch (e) {
      if (e.response?.status === 401) {
        localStorage.removeItem('tokenMANAGER');
        window.location.replace('/login');
      } else {
        setApprovalError(e.response?.status || 'network');
      }
    }
  };

  useEffect(() => {
    if (isApproved === "") {
      return;
    }
    handleClientApprovement();
  }, [isApproved]);

  if (!clientData) {
    return <Navigate to="/requests" replace />;
  }

  const renderComponent = (
    <>
      {clientData ? (
        <>
          <Header headerTitle={clientData.counterparty} backRedirect={-1} />
          <div style={{ paddingTop: "10px" }} className="clientInfoContainer">
            <h1 className="clientInfoHeader">Информация клиента</h1>
            {approvalError && <ConnectionError status={approvalError} onRetry={handleClientApprovement} />}
            <div className="clientInfoTxtWrapper">
              <span className="clientInfoSubHeading">Контрагент</span>
              <p className="clientInfoTxt">{clientData.counterparty}</p>
            </div>
            <div className="clientInfoTxtWrapper">
              <span className="clientInfoSubHeading">Грузполучатель</span>
              <p className="clientInfoTxt">{clientData.recipient}</p>
            </div>
            <div className="clientInfoTxtWrapper">
              <span className="clientInfoSubHeading">Адрес</span>
              <p className="clientInfoTxt">{clientData.deliveryPlace}</p>
            </div>
            <div className="clientInfoTxtWrapper">
              <span className="clientInfoSubHeading">Имя и фамилия</span>
              <p className="clientInfoTxt">{clientData.FIO}</p>
            </div>
            <div className="clientInfoTxtWrapper">
              <span className="clientInfoSubHeading">Номер телефона</span>
              <p className="clientInfoTxt">{clientData.number}</p>
            </div>
            <div className="clientInfoTxtWrapper">
              <span className="clientInfoSubHeading">Дата запроса</span>
              <p className="clientInfoTxt">{date.toLocaleString("ru")}</p>
            </div>
            <div className="clientInfoTxtWrapper">
              <span className="clientInfoSubHeading">Доступ</span>
              <div className="checkBox">
                <RadioButton checked={checked} setChecked={setChecked} />
                <span className="clientInfoTxt">Только просмотр</span>
              </div>
            </div>
          </div>
          <div className="footerSendButtonAddress">
            <div className="sendButtonPlaceholder">
              <button
                onClick={() => {
                  setIsApproved(true);
                }}
                className="sendButtonActive"
              >
                Подтвердить регистрацию
              </button>
              <button
                onClick={() => {
                  setIsApproved(false);
                }}
                className="rejectButtonActive"
              >
                Отменить регистрацию
              </button>
            </div>
          </div>
        </>
      ) : null}
    </>
  );

  return <React.Fragment>{renderComponent}</React.Fragment>;
}
